<div class="profile-form__form-container">
  <section>
    <form [formGroup]="accountSecurityForm" (ngSubmit)="onSubmit(f)" #f="ngForm">
      <h4>Change your password</h4>
      <br>
      <div class="profile-form__form-container__row">
        <mat-form-field class="default-form-input-container" appearance="outline">
          <span class="profile-form__icon"><i class="material-icons">lock</i></span>
          <input matInput placeholder="Current Password" data-automation-id="input_change_password_current_password" [formControlName]="'oldPassword'" type="password" (ngModelChange)="onInputChange(f)" required>
        </mat-form-field>
      </div>
      <div class="profile-form__form-container__row">
        <mat-form-field class="default-form-input-container" appearance="outline">
          <input matInput placeholder="New Password" [formControlName]="'password'" type="password" data-automation-id="input_change_password_new_password" (ngModelChange)="onInputChange(f)" (blur)="onBlur(f)" required>
        </mat-form-field>
      </div>
      <div class="profile-form__form-container__row">
        <mat-form-field class="default-form-input-container" appearance="outline">
          <input matInput placeholder="Verify Password" [formControlName]="'confirmPassword'" type="password" data-automation-id="input_change_password_verify_new_password" (ngModelChange)="onInputChange(f)"  (blur)="onBlur(f)" required>
        </mat-form-field>
      </div>
      <div *ngIf="passwordChangeFail" class="profile-form__form-container__row change-password-error-text-container" data-automation-id="change_password_change_fail">
        <p class="error-text">
          <span class="error-text-arrow"></span>
          {{passwordChangeFailText}}
        </p>
      </div>
      <div *ngIf="showUpdateSuccessfulText" class="profile-form__form-container__row mat-form-success ng-star-inserted" data-automation-id="change_password_success_message">
        <p class="success-text">
          <i class="material-icons">
            done
          </i>
          <span class="success-text-arrow"></span>{{successText}}
        </p>
      </div>
      <div class="profile-form__form-container__row" *ngIf="!passwordUpdatedSuccess">
        <p class="t-light small onboarding-password-form-input-container">
          Password must be at least 8 characters and contain at least one uppercase, lowercase and
          a digit or special character
        </p>
      </div>
      <div class="account-security-form-footer">
        <button type="button" (click)="closeSideBar()" class="a-rounded-button a-rounded-button--primary-outline" data-automation-id="button_change_password_cancel">Cancel</button>
        <button disableRipple class="a-rounded-button--primary a-rounded-button--medium form dialog__form-footer-button" type="submit"
          [disabled]="!f.valid" data-automation-id="button_change_password_submit">{{ 'Save' }}</button>
      </div>
    </form>
    <!-- TFA temporarily disabled -->
    <!-- <div class="col-md-6 col-sm-12 account-security-TFA-holder">
      <div class="col-md-8 col-sm-8" style="display: inline-block; padding: 0;">
        <h4>Two-step verification</h4>
      </div>
      <div class="col-md-4 col-sm-4" style="display: inline-block; padding: 0;"> {{tfaStatus}}
        <mat-slide-toggle disableRipple class="account-security-TFA-toggle" (change)="onTFAToggle($event)" [checked]="twoFactorEnabled">
        </mat-slide-toggle>
      </div>
    </div>
    <div class="tfa-status-container col-md-6 col-sm-12" *ngIf="twoFactorEnabled">
      <div class="col-md-12 col-sm-12">
        <div class="col-md-6 col-sm-6" style="display: inline-block;">
          <p>Preferred Methods</p>
        </div>
        <div class="col-md-6 col-sm-6" style="display: inline-block; text-align:right;">
          <p>{{twoFactorTypeLabel}}</p>
        </div>
      </div>
      <div class="col-md-12 col-sm-12">
        <div class="col-md-6 col-sm-6" style="display: inline-block;">
          <p>Choose how to get your security codes</p>
        </div>
        <div class="col-md-6 col-sm-6" style="display: inline-block; text-align:right;">
          <a disableRipple class="a-text-button small" (click)="toggleShowTFA()">Change</a>
        </div>
      </div>
    </div> -->
  </section>
  <app-spinner *ngIf="showSpinner" class="profile-spinner"></app-spinner>
</div>